import { render, staticRenderFns } from "./footerUI.vue?vue&type=template&id=560c2fa0&"
import script from "./footerUI.vue?vue&type=script&lang=js&"
export * from "./footerUI.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports